// extracted by mini-css-extract-plugin
export default {"imageWrapper":"sE-z","hovered":"tE-z","hoverImage":"uE-z","mainImage":"vE-z","imageNoBackground":"wE-z","fullSizeImage":"xE-z"};